// extracted by mini-css-extract-plugin
export default {"appButton":"Button_appButton__oa57T"};